const personalDashboardKpisReducer = (state = null, action) => {
    switch (action.type) {
        case 'SET_PERSONAL_DASHBOARD_KPIS':
            return action.payload
        default:
            return state
    }
}

export default personalDashboardKpisReducer
